import React from "react";
import { Redirect } from "expo-router";

const Questionnaires = () => {
  return <Redirect href={"/"} />;
};

export default Questionnaires;
